import { useAuthStore } from '../auth/store';
import { KpiCard } from '../components/ui';

export function DashboardPage(): JSX.Element {
  const me = useAuthStore((s) => s.me)!;
  const displayName = me.user.display_name || me.user.email;

  // NOTE: These KPI figures are static placeholders for the shell. The real
  // values are wired to live queries (clock_events headcount, open incidents,
  // expiring credentials, unfilled assignments) during Integration.
  return (
    <div className="dashboard-page">
      <section className="dashboard-welcome">
        <h2>
          Welcome back, <span className="dashboard-name">{displayName}</span>
        </h2>
        <p className="dashboard-sub">Operational snapshot across active sites and details.</p>
      </section>

      <section className="kpi-grid">
        <KpiCard label="On-duty headcount" value="—" meta="officers clocked in" />
        <KpiCard label="Open incidents" value="—" meta="awaiting review" tone="warn" />
        <KpiCard
          label="Expiring credentials"
          value="—"
          meta="within 60 days"
          tone="danger"
        />
        <KpiCard label="Unfilled shifts" value="—" meta="next 7 days" tone="warn" />
      </section>

      <section className="dashboard-card dashboard-empty">
        <p>
          Live operational widgets — duty roster, incident feed, credential
          expirations, and post-coverage gaps — appear here once the domain
          modules are connected.
        </p>
      </section>
    </div>
  );
}
